const OutlineWarningIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
    >
      <path
        d="M18.9966 14.3343V20.5566M18.9966 26.7788H19.0121M16.8426 6.38813L4.04836 28.4873C3.33871 29.7131 2.98389 30.326 3.03633 30.829C3.08207 31.2677 3.31194 31.6664 3.66871 31.9258C4.07776 32.2232 4.78594 32.2232 6.20232 32.2232H31.7908C33.2072 32.2232 33.9154 32.2232 34.3244 31.9258C34.6812 31.6664 34.9111 31.2677 34.9568 30.829C35.0093 30.326 34.6544 29.7131 33.9448 28.4873L21.1505 6.38813C20.4434 5.16677 20.0899 4.55608 19.6286 4.35098C19.2262 4.17207 18.7669 4.17207 18.3646 4.35098C17.9033 4.55608 17.5497 5.16677 16.8426 6.38813Z"
        stroke="#1F1F1F"
        stroke-width="2.07407"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default OutlineWarningIcon;
